module.exports = __webpack_public_path__ + "media/images/many-california-renters-remain-financially-stressed-figure-1-cf1a141690ff146fbdf013571b2aaf04.png";